<template>
  <main class="signup__main">
    <section class="container">
      <div class="full-height-wrap">
        <card-form>
          <sign-up-form/>
        </card-form>
      </div>
    </section>
  </main>
</template>

<script>
import SignUpForm from '../forms/SignUpForm/SignUpForm';
import CardForm from '../components/CardForm/CardForm';

export default {
  name: 'SignUpPage',
  components: {
    SignUpForm,
    CardForm,
  },
};
</script>
